import React from "react";
import { useSelector } from "react-redux";
import { InsertChart as InsertChartIcon } from "@mui/icons-material";
import { Button } from "@mui/material";

import { Architecture, Project, Store } from "fond/types";
import { Modal } from "fond/widgets";

import BomContent from "./BomContent";
import InteractiveBomStatus from "./InteractiveBomStatus";
import { useInteractiveBomStatus } from "./useInteractiveBomStatus";

interface InteractiveBomModalProps {
  project: Project;
  architecture: Architecture | null;
  onClose(): void;
}

const InteractiveBomModal: React.FC<InteractiveBomModalProps> = ({ project, architecture, onClose }: InteractiveBomModalProps) => {
  const versionId = useSelector((state: Store) => state.project.versionId);
  const { status, bomArchRestrictions } = useInteractiveBomStatus({ project, versionId });

  return (
    <Modal
      fullscreen
      showClose
      open
      onClose={onClose}
      variant="primary"
      header="Bill of materials"
      headerSubtitle="MATERIALS & COSTS"
      headerIcon={<InsertChartIcon />}
      data-testid="interactive-bom-modal"
      DialogContentProps={{ style: { display: "flex", flexDirection: "column", minHeight: 0 } }}
      content={
        <InteractiveBomStatus status={status}>
          {status.kind === "ready" && (
            <BomContent project={project} architecture={architecture} bom={status.bom} bomArchRestrictions={bomArchRestrictions} />
          )}
        </InteractiveBomStatus>
      }
      actions={
        <Button data-testid="interactive-bom-modal-close-button" onClick={onClose}>
          Close
        </Button>
      }
    />
  );
};

export default InteractiveBomModal;
